var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup22089White(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22089",
    "data-name": "Group 22089",
    transform: "translate(-2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38304",
    "data-name": "Path 38304",
    d: "M16.382,8.218a.607.607,0,0,0-1.194.221,6.141,6.141,0,0,1,.1,1.046A5.792,5.792,0,1,1,9.5,3.708a5.608,5.608,0,0,1,2.255.457.608.608,0,0,0,.472-1.12A7.2,7.2,0,0,0,9.5,2.5a7,7,0,1,0,7,7A7.277,7.277,0,0,0,16.382,8.218Z",
    transform: "translate(0 -2.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38305",
    "data-name": "Path 38305",
    d: "M27.971,13.58c-.722-1.046-2.446-.044-1.709,1,.884,1.267,1.695,2.594,2.579,3.861a1.006,1.006,0,0,0,1.709,0A42.58,42.58,0,0,1,36,11.045c.884-.914-.516-2.328-1.4-1.4a40.491,40.491,0,0,0-4.937,6.484C29.106,15.274,28.561,14.42,27.971,13.58Z",
    transform: "translate(-20.107 -8.333)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup22089White);
export default __webpack_public_path__ + "static/media/Group 22089_white.54849d90212a35f01c22c4613de22152.svg";
export { ForwardRef as ReactComponent };